import {
  CreateDonationArgs,
  CreateDonationSessionArgs,
  UserType,
} from "@ecologi/shared";
import { fetchFromAPI } from "./fetch-from-api";

export const createDonationCharge = async ({
  args,
  accessToken,
}: {
  args: CreateDonationArgs;
  accessToken: string;
}): Promise<UserType> =>
  fetchFromAPI("/donations/one-time", {
    method: "POST",
    body: JSON.stringify(args),
    passthrough: "api",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

export const createDonationSession = async ({
  args,
  accessToken,
}: {
  args: CreateDonationSessionArgs;
  accessToken: string;
}) =>
  fetchFromAPI("/donations/session", {
    method: "POST",
    body: JSON.stringify(args),
    passthrough: "api",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
